var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foldWrapper"},[_c('div',{staticClass:"w3-button",on:{"click":function($event){return _vm.toggleContent()}}},[_vm._v(_vm._s(_vm.labelText))]),_c('div',{class:{hidden: _vm.contentHidden}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }